import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

const getTrustpilotTheme = () => {
    if (typeof document !== 'undefined') {
        const bodyHasDarkMode = document.body && document.body.classList.contains('dark-mode');
        const htmlHasDarkMode = document.documentElement && document.documentElement.classList.contains('dark-mode');
        if (bodyHasDarkMode || htmlHasDarkMode) {
            return 'dark';
        }
    }

    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    return 'light';
};

const TrustBoxReviewCollector = ({ trustBoxRef, settings, trustpilotTheme }) => (
    /*< !--TrustBox widget - ReviewCollector-- >*/
    <div ref={trustBoxRef} // We need a reference to this element to load the TrustBox in componentDidMount.
        className="trustpilot-widget d-inline-block pt-2" // Renamed this to className.
        data-locale={settings.locale} data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id={settings.trustPilotBusinessUnitId} //"6037915b07033f0001d0198b"
        data-style-height="44px"
        data-style-width="100%"
        data-style-border-radius="22px"
        data-style-border-border="1px solid #0ea5e9"
        data-theme={trustpilotTheme}>
        <a href={`https://trustpilot.com/review/${settings.customDomain}`} samesite='Secure' target="_blank" rel="noopener">Trustpilot</a>
    </div>
    /*<!--End TrustBox widget-- >*/
);


class TrustBoxReviewCollectorContainer extends Component {
    constructor(props) {
        super(props);
        this.trustBoxRef = React.createRef();
    }

    componentDidMount() {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    }

    render() {
        const { settings } = this.props;
        const trustpilotTheme = getTrustpilotTheme();
        return <TrustBoxReviewCollector trustBoxRef={this.trustBoxRef} settings={settings} trustpilotTheme={trustpilotTheme} />;
    }
}


function mapStateToProps({ settings }) {
    return { settings };
}

export default withTranslation()(connect(mapStateToProps, null, null, { forwardRef: true })(TrustBoxReviewCollectorContainer));
